import { render, staticRenderFns } from "./UmsTenantEditor.vue?vue&type=template&id=72056896&"
import script from "./UmsTenantEditor.vue?vue&type=script&lang=js&"
export * from "./UmsTenantEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports